import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @description Treats a whitespace-only string as empty. `Validators.required`
 * accepts `"   "`, but the value is trimmed before it is sent, so the backend
 * would receive an empty string and reject it with a generic 400. Returns the
 * same `{ required: true }` error so the existing "is required" message shows.
 * @returns {ValidatorFn} The validator function
 */
export function notBlankValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (typeof value !== 'string' || value.length === 0) return null;
    return value.trim().length === 0 ? { required: true } : null;
  };
}
